function addCart() {
	const _removeCurrencyFormat = function (rate) {
		rate = rate.substring(1);
		rate = rate.replace(",", "");
		return rate;
	}

	const _addCurrencyFormat = function (rate, currency) {
		return currency + rate.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}
	const discountTable = [{
		code: "9af01331094d4164538a4b18a1f06afbcc13c08a2f0cf3eb926693c3ed6045b6", 'value': 300,
		start: new Date('2022, 7, 1 0:00:00 +09:00'), 'end': new Date('2022, 8, 1 00:00:00 +09:00')
	},
		{
			code: "", 'value': 0,
			start: new Date('2020, 1, 1 0:00:00 +09:00'), 'end': null
		}
	];


	const getCookie = function (name) {
		const value = "; " + document.cookie;
		const parts = value.split('; ' + name + '=');
		if (parts.length === 2) return parts.pop().split(";").shift();
	};

	const codeCookieValue = decodeURI(getCookie('discount_code'));
	if (!codeCookieValue) {
	}

	const discountHash = SHA256(codeCookieValue);
	const now = new Date();
	let discountValue = 0;

	const money = document.querySelector('.cart-table .subtotal-price');
	const currency = money.innerText[0];

	for (const discount of discountTable) {
		if (discount.code === discountHash) {
			if (now > discount.start && (discount.end == null || now < discount.end)) {
				discountValue = discount.value;
				document.querySelector('.discount-code').innerHTML = codeCookieValue;
				document.querySelector('.discount-value').innerHTML = _addCurrencyFormat(discountValue, currency);
				document.querySelector('.discounts').setAttribute('style', "");
			}
			break;
		}
	}

	let subtotal = 0;
	let shipping = 0;
	let total = 0;

	const svgDiscount = document.createElement("svg");
	svgDiscount.setAttribute('xmlns', "http://www.w3.org/2000/svg");
	svgDiscount.setAttribute('viewBox', "0 0 18 18");
	svgDiscount.setAttribute('style', "width:18px;height:18px;vertical-align: -3px;margin-right: 3px;");
	svgDiscount.innerHTML = '<path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55"></path><path d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path>'

	subtotal = _removeCurrencyFormat(money.innerText);
	if (document.querySelector('.cart-table .shipping-cost')) {
		shipping = _removeCurrencyFormat(document.querySelector('.cart-table .shipping-cost').innerText);
	}

	if (subtotal < 0) {
		subtotal = 0
	}
	total = Number(subtotal) + Number(shipping) - Number(discountValue);
	if (total < 0) {
		total = 0
	}
	if (isNaN(total)) {
		total = subtotal
	}
	document.querySelector('.cart-table .total-price').innerHTML = _addCurrencyFormat(total, currency);

	const spanHeaderValue = document.createElement("span");
	if (document.querySelector('.nav-list .cart-total')) {

		const headerCart = document.querySelector('.nav-list .cart-total');
		headerCart.querySelector('.money').setAttribute('style', "display: none;");
		headerCart.append(spanHeaderValue);
	}

	spanHeaderValue.innerHTML = _addCurrencyFormat(total, currency);


	const config = {attributes: true, childList: true, subtree: true};

	const callback3 = function () {
		observer4.disconnect();
		if (document.querySelector("#address_province_container .dropdown__button")) {
			observer4.observe(document.querySelector("#address_province_container .dropdown__button"), config);
			clearInterval(interval)
			observer2.observe(money, config);
		}
	};

	const interval = setInterval(callback3, 1000)

	const callback2 = function () {
		const japanList = jQuery('[data-value="Japan"]')
		if (japanList.length && !jQuery('[data-value="Aichi"]').length) {
			japanList[0].click();
		}
		jQuery(".get-rates")[0].click();
	};

	const callback = function () {
		subtotal = _removeCurrencyFormat(money.innerText);
		if (document.querySelector('.cart-table .shipping-cost')) {
			shipping = _removeCurrencyFormat(document.querySelector('.cart-table .shipping-cost').innerText);
		}
		total = Number(subtotal) + Number(shipping) - Number(discountValue);
		if (total < 0) {
			total = 0
		}
		if (isNaN(total)) {
			total = subtotal
		}
		document.querySelector('.cart-table .total-price').innerHTML = _addCurrencyFormat(total, currency);
		spanHeaderValue.innerHTML = _addCurrencyFormat(total, currency);
	};

	const observer = new MutationObserver(callback);
	const observer2 = new MutationObserver(callback2);
	const observer4 = new MutationObserver(callback2);

	observer.observe(document.getElementById("wrapper-response"), config);

	document.querySelector('.cart .cart__checkout-btn .btn').setAttribute('style', "display: none;");
	const newButton = document.createElement("div");
	document.querySelector('.cart .cart__checkout-btn').append(newButton);
	newButton.setAttribute('class', "btn btn--default btn--full purchase-button");
	newButton.setAttribute('style', "width: calc(100% - 60px);");
	newButton.innerHTML = "購入する";

	document.querySelector('.purchase-button').onclick = () => {
		document.cookie = "discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
		document.querySelector('.cart__checkout-btn .btn.btn--default.btn--full').click();
	}
	/*
	var checkCountry = setInterval(function () {

	  var countryDropdown = document.querySelector('li[data-value="Japan"]');
	  var stateDropdown = document.querySelector('li[data-value="Akita"]');

	  if (stateDropdown) {
		stateDropdown.click();
		updateCart();
		clearInterval(checkCountry);
	  } else if (document.querySelector(".shipping-calculator__container .field .dropdown") && countryDropdown) {
		countryDropdown.click();
	  }
	}, 1000);*/
}

addCart();
